/**
 * @desc 保存会员企业认证
 */
import {
  AuditEnterpriseEntity,
  AuditEnterpriseForm
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateAuditEnterpriseParameter = AuditEnterpriseForm

const method = 'POST'
const url = '/auth/audit/enterprise'

export const createAuditEnterpriseApi = (
  data?: CreateAuditEnterpriseParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuditEnterpriseEntity>({
    method,
    url,
    data,
    ...config
  })
}

createAuditEnterpriseApi.method = method
createAuditEnterpriseApi.url = url
